export function KnolskapeLogo({ className = '' }: { className?: string }) {
  return (
    <img
      src="/knolskape_logo.png"
      alt="KNOLSKAPE"
      className={`h-11 w-auto object-contain ${className}`}
    />
  );
}
